import { ChevronLeft, ChevronRight } from 'lucide-react'

interface NavButtonsProps {
  /** Label on the right-side advance button — e.g. "Users & Use Cases". */
  nextLabel?: string
  /** Disabled when there's no previous section (i.e. section 1). */
  prevDisabled?: boolean
  onPrev?: () => void
  onNext?: () => void
}

/**
 * The Previous / Next button bar that sits at the bottom of each
 * intake section. Mirrors `<div class="nav-buttons">` in the original
 * lorenza.html. The CSS for `.nav-buttons` + `.nav-btn` is already in
 * `styles/briefer.css`.
 */
export function NavButtons({ nextLabel, prevDisabled, onPrev, onNext }: NavButtonsProps) {
  return (
    <div className="nav-buttons">
      <button type="button" className="nav-btn outline" disabled={prevDisabled} onClick={onPrev}>
        <ChevronLeft size={14} />
        Previous
      </button>
      {nextLabel && (
        <button type="button" className="nav-btn" onClick={onNext}>
          Next: {nextLabel}
          <ChevronRight size={14} />
        </button>
      )}
    </div>
  )
}
